import { ChangeDetectionStrategy, Component, input, model } from '@angular/core'

@Component({
   selector: 'vc-multi-select',
   templateUrl: './multi-select.component.html',
   styleUrl: './multi-select.component.scss',
   standalone: false,
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VcMultiSelectComponent {
   label = input<string>('Select Options')
   required = input<boolean>(false)
   sizeClass = input<'v-multiselect-sm' | 'v-multiselect-md' | 'v-multiselect-lg' | 'v-multiselect-full'>('v-multiselect-md')
   variantClass = input<string>('v-defaultfilter')
   inputId = input<string>('vc-multiselect')
   options = input<Array<any>>([])
   optionLabel = input<string>('label')
   optionValue = input<string | null>('value')
   placeholder = input<string>('Select')
   disabled = input<boolean>(false)
   optionDisabled = input<string | null>(null)
   showClear = input<boolean>(true)
   selectedItems = model<Array<any>>([])
   //model = model<Array<any>>(this.selectedItems())
   appendTo = input<string | null>(null)
   display = input<string>('comma')
   selectedItemsLabel = input<string>('{0} items selected')

   onSelectionChange(event: any) {
      //this.model.set(event.value)
   }
}
